export default __webpack_public_path__ + "static/media/Group 2.c7459bc8.svg";